module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d275d18e306a6c36ccfa827bed3f4d45.png";